import React, { Component }         from 'react';
import {connect}                    from 'react-redux';
import { Field, reduxForm, reset,change }  from 'redux-form';
import $                            from 'jquery';
import moment                       from 'moment';
import {Link,Redirect}              from 'react-router-dom';
import validate                     from '../../../service/validate_tarefas';
import renderDatePicker             from '../../../container/renderDatePicker';
import renderFieldTextArea          from '../../../container/renderFieldTextArea';
import renderField                  from '../../../container/renderField';
import renderFieldRadio             from '../../../container/renderFieldRadio';
import renderFiles                  from '../../../container/renderFiles';
import RenderSelectFile             from '../../../container/renderSelectFile';
import { SetEditarTarefas,
         GetTarefa}                 from '../../../actions/tarefaAction';
import {SetError}                   from '../../../actions/notificacaoAction';
import {GetListaMenuTopo,
         GetListaSubMenuTopo}       from '../../../actions/scopoAction';
import {SetValidUrlYoutube,
        ClearUrl}                   from '../../../actions/turmaAction';


class TarefaProfessorCadastro extends Component {

    constructor(props){
        super(props);
        this.state = {
                        listaFilesMidias       :[],
                        listaFilesAnexos       :[],
                        use_id                 : this.props.session.id,
                        dataInicio             : moment(),
                        dataFim                : moment(),
                        habilitarInicio        : false,
                        habilitarFim           : true,
                        tar_id                 : this.props.match.params.tar_id,
                        redirect               : false,
                        buttonDisabled         : false,
                        statusMidias           : null,
                        fileMidia              : '',
                        statusCheckEquipe              : '',
                        valMax                 : 80,
                        countDinamic           : 80,
                        valMaxContexto         : 400,
                        countDinamicContexto   : 400,
                        valMaxObjetivo         : 200,
                        countDinamicObjetivo   : 200,
                        valMaxRecompensa       : 40,
                        countDinamicRecompensa : 40,
                        load : false,
                    }
                    this.onChangeVideo = this.onChangeVideo.bind(this);                   
    }

    componentWillMount() {

            this.props.GetTarefa(this.props.session.id,this.state.tar_id).then((reponse) =>{

                const retorno = reponse.data;
                this.props.initialize({
                    titulo: retorno.tar_titulo,
                    descricao: retorno.tar_descricao,
                    objetivo: retorno.tar_objetivo,
                    txt_recompensa: retorno.tar_txt_recompensa,
                    tar_data_inicio: moment(retorno.tar_data_inicio).format('DD/MM/YYYY'),
                    tar_data_fim: moment(retorno.tar_data_fim).format('DD/MM/YYYY'),
                    flag_equipe: String(retorno.tar_flag_entrega_equipe),
                    tar_flag_resposta: String(retorno.tar_flag_resposta),
                    tar_nome_turma: retorno.tar_nome_turma,
                    tipo_midia: String(retorno.tar_tipo_midia),
                    link: retorno.tar_anexo,
                    anexo: retorno.tar_anexo,
                    tar_midia: retorno.tar_midia,
                });
        
                this.setState({
                    load                   : true,
                    titulo                 : retorno.tar_titulo,
                    habilitarInicio        :(retorno.tar_status == 0 ? false:true),
                    tar_status             : retorno.tar_status,
                    countDinamic           : this.state.valMax-retorno.tar_titulo.length,
                    descricao              : retorno.tar_descricao,
                    countDinamicContexto   : this.state.valMaxContexto-retorno.tar_descricao.length,
                    txt_recompensa         : retorno.tar_txt_recompensa,
                    countDinamicRecompensa : this.state.valMaxRecompensa-retorno.tar_txt_recompensa.length,
                    objetivo               : retorno.tar_objetivo,
                    countDinamicObjetivo   : this.state.valMaxObjetivo-retorno.tar_objetivo.length,
                    tar_data_inicio        : retorno.tar_data_inicio,
                    tar_data_fim           : retorno.tar_data_fim,
                    tar_data_entrega       : retorno.tar_data_entrega,
                    opcao_tipo_midia       : retorno.tar_tipo_midia,
                    turma                  : retorno.tar_nome_turma,
                    tar_anexo              : 1,
                    selectFiles            : (retorno.tar_anexo ? <RenderSelectFile nome="Anexo" funcao={this.removerAnexoMissao.bind(this)} /> : null),
                    tar_midia              : retorno.tar_midia,
                    selectFilesMidia       : (retorno.tar_tipo_midia === 0 ? false : (retorno.tar_tipo_midia === 1 ? <RenderSelectFile nome="Mídia" funcao={this.removerMidiaMissao.bind(this)} /> : <a href={`https://www.youtube.com/watch?v=${retorno.tar_midia}`} target="_black">Link Vídeo</a>))
                });

        this.addCampoMidia(retorno.tar_tipo_midia);

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:"Unidade Curricular",link:this.props.menu.missao.home},
            {action:true,nome:'Missão',link:`${this.props.menu.missao.missao_lista}/${retorno.tar_cod_turma}/${retorno.tar_cod_disciplina}}`},
            {action:false,nome:'Editar'},
        ]);

        this.props.GetListaSubMenuTopo([]);
         
        }).catch( 
            (error) =>{
            this.props.SetError(500);
        });

    

      
        this.props.initialize('tarefa_form',{'opcao_tipo_midia':0},false)
    }
 
    removerMidiaMissao(){
        const acao = window.confirm("Deseja remover essa mídia?");
        if(acao) {
           this.setState({ selectFilesMidia: [], statusMidias: false, tipo_midia: 0 });
           this.addCampoMidia(0);
           this.props.dispatch(change('tarefa_form', 'tipo_midia', "0"));
           this.props.dispatch(change('tarefa_form', 'tar_midia', ""));
        }       
    }

    removerAnexoMissao(){
        const acao = window.confirm("Deseja remover o anexo?");
        if (acao) {
            this.setState({ selectFiles: null, tar_anexo: 0 });
            this.props.dispatch(change('tarefa_form', 'tar_file', false));

        }       
    }

    loadListUpload(dados){
        const list = dados.file;
        const funcao = dados.funcao;
        return list.map((elem, i) => {
            return <div className="uploadFileSelect" key={i}>
                <span className="pull-left"><span className={dados.icon}></span> {elem.name}</span>
                <span className="pull-right">
                    <button onClick={funcao.bind(this, i)} className="btn btn-link btn-xs">x</button>
                </span>
            </div>;
        });
    }

    onDrop(files) {
       const retorno = this.loadListUpload({file:files,nome:'Documento',icon:'glyphicon glyphicon-file',funcao:this.resetUpload});
       this.setState({selectUpload:1,filesDocumento:files, selectFiles:retorno});
    }

    onDropMidia(files) {      
         const retorno = this.loadListUpload({file:files,nome:'Mídia',icon:'glyphicon glyphicon-picture',funcao:this.resetUploadMidia});
         this.setState({uploadMidia: 1, fileMidia: files , selectFilesMidia:retorno});            
    }

    resetUpload(val){
     
        Array.prototype.remove = function(start, end) {
          this.splice(start, end);
          return this;
        }
        this.state.filesDocumento.remove(val, 1);
        this.setState({selectFiles:null,tar_anexo:0});
        this.props.dispatch(change('tarefa_form', 'tar_file', 0));
    }

    resetUploadMidia(val){
     
        Array.prototype.remove = function(start, end) {
          this.splice(start, end);
          return this;
        }
        this.state.fileMidia.remove(val, 1);
        this.setState({selectFilesMidia:null});
        this.props.dispatch(change('tarefa_form', 'tipo_midia', "0"));
        this.props.dispatch(change('tarefa_form', 'tar_midia', ""));

    }

    dataInicioChange(e){
      this.setState({dataInicio:moment(e, 'YYYY-MM-DD', true) ,habilitarFim:false})
    }
    
    dataFimChange(e){
      this.setState({dataFim:moment(e,'YYYY-MM-DD', true),habilitarEntrega:false})
    }

    handleSubmit(e){
       
        let dados = {
            tar_titulo: e.titulo,
            tar_descricao: e.descricao,
            tar_objetivo: e.objetivo,
            tar_txt_recompensa: e.txt_recompensa,
            tar_data_inicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            tar_data_fim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            tar_tipo_midia: e.tipo_midia,
            tar_flag_resposta: e.tar_flag_resposta,
            tar_midia: e.tipo_midia === '0' ? this.state.statusMidias : (e.tipo_midia == "1" ? (e.tar_midia.length == 1 ? e.tar_midia[0] : true) : this.props.ClearUrl(e.tar_midia)),
            tar_cod_usuario: this.state.use_id,
            tar_id: this.state.tar_id,
            tar_flag_entrega_equipe: e.flag_equipe,
            tar_cod_dis_tur: e.tar_cod_dis_tur,
            tar_anexo: (e.tar_file ? e.tar_file[0] : this.state.tar_anexo)
        }
     
        this.props.SetEditarTarefas(dados).then((response) => {
            this.setState({redirect:true});
           alert("Ação realizada com sucesso!");           
        }).catch((error)=>{
            this.props.SetError(500);
        });  
    }

    addCampoMidia(ev){
   
        var obj = {};
     
        switch (ev) {
            case 0:
                obj.midia = "";
                    this.setState({ selectFilesMidia: [] });
                    this.props.dispatch(change('tarefa_form', 'tar_midia', ""));
                break;

            case 1:
                obj.midia = <Field label="Imagem" textField="Selecionar imagem..." component={renderFiles} name="tar_midia" accept="image/jpeg, image/png" funcao={this.onDropMidia.bind(this)} />;
                this.setState({ selectFilesMidia:(this.state.opcao_tipo_midia ==2?[]:this.state.selectFilesMidia)});
                break;

            case 2:
                obj.midia = <div><Field label="Adicionar vídeo do Youtube" name="tar_midia" className="form-control" onChange= {this.onChangeVideo}  component={renderField} /><div className="valid-url"></div></div>;
                this.props.dispatch(change('tarefa_form', 'tar_midia', ""));
                this.setState({ selectFilesMidia:(this.state.opcao_tipo_midia ==1?[]:this.state.selectFilesMidia)});
      
                break;

            default:
                break;
        }
     
        this.setState({ opcao_tipo_midia: ev,
                       midia: obj.midia,
                       buttonDisabled:(parseInt(ev)==1 || parseInt(ev)==0?false:true)
                     });

    }

    addCampoSelecaoResposta(ev){
      this.setState({tar_flag_resposta: ev.target.value })
    }

    countCaractere(e){
        const text_remaning = this.state.valMax - e.target.textLength;
        this.setState({countDinamic:text_remaning})
    }

    countCaractereContexto(e){

        const text_remaning = this.state.valMaxContexto - e.target.textLength;
        this.setState({countDinamicContexto:text_remaning})
    }

    countCaractereObjetivo(e){

        const text_remaning = this.state.valMaxObjetivo - e.target.textLength;
        this.setState({countDinamicObjetivo:text_remaning})
    }

    countCaractereRecompensa(e){

        const text_remaning = this.state.valMaxRecompensa - e.target.textLength;
        this.setState({countDinamicRecompensa:text_remaning})
    }

    onChangeVideo(e) {

        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ? e.target.value:""),
                       // validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1),
                        buttonDisabled:(retValid === 1 ? false:true)
                      }); 
  
        if (retValid) {
             $('.valid-url').html("");
        }else{
            this.props.dispatch(change('tarefa_form', 'tar_midia', "0"));
            $('.valid-url').html('<span class="text-danger"><b>Copie e cole uma url válida do Youtube.</b> </span>');         
        }
       
    }

    checkActionEquipe(e){
        const val = e.target.value;
        this.setState({statusCheckEquipe:(parseInt(val)===1? <div className='form-group'><div className='alert alert-info' role='alert'>Certifique-se de que todos os alunos nas turmas selecionadas estejam em uma equipe</div></div>:"")});
    }

    render(){

        const {handleSubmit} = this.props;
        if (this.state.redirect) {
           return (<Redirect to={this.props.menu.missao.home}/>);
        }

        return (
                <div className="container-bg">
                    <div className="panel panel-azul-claro">
                        <div className="panel-body">
                            <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                <div className="form-group">
                                    <label className="control-label">Turma</label>
                                    <input type="text" className="form-control" disabled value={this.state.turma} />
                                </div>
                                <span className="count pull-right">{this.state.countDinamic && this.state.countDinamic}</span>
                                <Field name="titulo" label="Título*" length={this.state.valMax} onChange={this.countCaractere.bind(this)} component={renderFieldTextArea} />
                                <div className="row">
                                    <div className="col-sm-6">
                                    <span className="count pull-right">{this.state.countDinamicContexto && this.state.countDinamicContexto}</span>
                                        <Field name="descricao" label="Contexto*" length={this.state.valMaxContexto} onChange={this.countCaractereContexto.bind(this)} component={renderFieldTextArea} type="textarea" />
                                    </div>
                                    <div className="col-sm-6">
                                    <span className="count pull-right">{this.state.countDinamicObjetivo && this.state.countDinamicObjetivo}</span>
                                     <Field name="objetivo" label="Objetivo" length={this.state.valMaxObjetivo} onChange={this.countCaractereObjetivo.bind(this)} component={renderFieldTextArea} />
                                        
                                    </div>
                                </div>
                                <span className="count pull-right">{this.state.countDinamicRecompensa && this.state.countDinamicRecompensa}</span>
                                        <Field name="txt_recompensa" label="Recompensa" length={this.state.valMaxRecompensa} onChange={this.countCaractereRecompensa.bind(this)}  component={renderFieldTextArea} type="textarea" />
                                
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Field label="Data Ínicio*" component={renderDatePicker} habilitar={this.state.habilitarInicio} name="tar_data_inicio" onChange={this.dataInicioChange.bind(this)} />
                                    </div>
                                    <div className="col-sm-6">
                                        <Field label="Data Fim*" minData={this.state.tar_data_inicio} component={renderDatePicker} name="tar_data_fim" onChange={this.dataFimChange.bind(this)} />
                                    </div>
                                </div>
                                <hr />
                                <div className="form-group">
                                    <label className="control-label">Missão em equipe?*</label>
                                    <Field name="flag_equipe" type="radio" onChange={this.checkActionEquipe.bind(this)} component={renderFieldRadio} value="1" label="Sim" />
                                    <Field name="flag_equipe" type="radio" onChange={this.checkActionEquipe.bind(this)} component={renderFieldRadio} value="0" label="Não (Individual)" />
                                </div>
                                {this.state.statusCheckEquipe}
                                <hr />
                                <div className="form-group">
                                    <label className="control-label">Aluno Enviará Resposta (PDF, RAR ou ZIP)?*</label>
                                    <Field name="tar_flag_resposta" type="radio" component={renderFieldRadio} onChange={this.addCampoSelecaoResposta.bind(this)} value="1" label="Sim" />
                                    <Field name="tar_flag_resposta" type="radio" component={renderFieldRadio} onChange={this.addCampoSelecaoResposta.bind(this)} value="0" label="Não" />
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label className="control-label">Adicionar Mídia?</label>
                                            <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this, 0)} value="0" label="Nenhuma" />
                                            <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this, 1)} value="1" label="Imagem" />
                                            <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this, 2)} value="2" label="Vídeo" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        {this.state.opcao_tipo_midia > 0 ? this.state.midia : ""}
                                        {this.state.selectFilesMidia ? this.state.selectFilesMidia : ""}
                                    </div>
                                </div>
                                <hr />
                                <div className="form-group">
                                    <Field 
                                        label="Anexar Item de Missão (Opcional)"                                        
                                        textField="Selecionar Arquivo" 
                                        component={renderFiles} 
                                        name="tar_file" 
                                        accept=".pdf,.zip,.rar,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx" 
                                        funcao={this.onDrop.bind(this)} 
                                     />
                                    {this.state.selectFiles}
                                </div>
                                <a href={void(0)} onClick={() =>this.props.history.goBack()} className="btn btn-sm btn-primary">Voltar</a>
                                <button type="submit" disabled={this.state.buttonDisabled} className="btn btn-primary btn-sm pull-right">Salvar</button>
                            </form>
                        </div>
                    </div>
                </div>            
        );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('tarefa_form'));
function mapStateToProps(state){

    return {
             session : state.auth.session,
             curso   : state.turmaReducer.allRankingCurso,
             turma   : state.tarefaReducer.all_turma_professor,
             menu    : state.configReducer.menu
           }
}

export default reduxForm({
  form                     : 'tarefa_form',
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true,
  onSubmitSuccess          : afterSubmit,
 validate
})(connect(mapStateToProps, {
                              SetEditarTarefas,
                              GetListaMenuTopo,
                              GetListaSubMenuTopo,
                              SetValidUrlYoutube,
                              GetTarefa,
                              ClearUrl,
                              SetError
                             })(TarefaProfessorCadastro));
 {/* textField="Selecionar Arquivo (PDF,ZIP,RAR,JPG,JPEG,PNG,DOC,DOCX,XLS,XLSX,PPT,PPTX)"*/}


// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_editar.js